var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          ref: "chatIcon",
          staticClass: "chatbot-icon",
          class: {
            "chic-animate": _vm.clickAnimation,
            "smoke-active": _vm.smokeActive,
          },
          style: _vm.chatbotStyle,
          on: { pointerdown: _vm.onPointerDown },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("img", {
            staticClass: "img-fluid chatbot-img",
            style: { transform: `rotate(${_vm.tiltAngle}deg)` },
            attrs: { src: "/assets/images/chatBot.svg", alt: "Chatbot" },
          }),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.trailParticles, function (p) {
        return _c("div", {
          key: p.id,
          staticClass: "trail-particle",
          style: p.style,
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.chatVisible,
              expression: "chatVisible",
            },
          ],
          ref: "chatbox",
          staticClass: "chatbox shadow",
          class: { expanded: _vm.isExpanded },
          style: _vm.chatboxStyle,
        },
        [
          _c(
            "div",
            {
              staticClass:
                "chatbox-header d-flex align-items-center justify-content-between p-3",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn minmax-btn p-0",
                  on: { click: _vm.toggleExpand },
                },
                [
                  !_vm.isExpanded
                    ? _c("img", {
                        staticClass: "maximize",
                        attrs: {
                          src: "/assets/images/expand-chat.svg",
                          alt: "Expand",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isExpanded
                    ? _c("img", {
                        staticClass: "minimize",
                        attrs: {
                          src: "/assets/images/minimize-3.svg",
                          alt: "minimize",
                        },
                      })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chat-title d-flex align-items-center gap-1" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("h5", { staticClass: "chat-name mb-0 font-weight-bold" }, [
                    _vm._v(
                      _vm._s(_vm.Lang.get("messages.smart_school_assistant"))
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn p-0 close-chat",
                  on: { click: _vm.toggleChat },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/assets/images/close-circle-white.svg",
                      alt: "Close",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { ref: "chatboxBody", staticClass: "chatbox-body p-3" },
            [
              _vm.showWelcomeMessage
                ? _c(
                    "div",
                    { staticClass: "chatbox-message bot d-flex mb-3 gap-2" },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "message-content" }, [
                        _c("p", { staticClass: "mb-1 message-txt" }, [
                          _vm._v(
                            _vm._s(_vm.Lang.get("messages.welcome_message"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between",
                          },
                          [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(_vm.currentTime)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn p-0 speaker-btn",
                                class: {
                                  speaking: _vm.playingMessageIndex === -1,
                                },
                                attrs: {
                                  disabled: _vm.isLoadingAudio,
                                  title: _vm.Lang.get(
                                    "messages.listen_to_message"
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.playTextToSpeech(
                                      _vm.Lang.get("messages.welcome_message"),
                                      -1
                                    )
                                  },
                                },
                              },
                              [
                                _vm.playingMessageIndex !== -1
                                  ? _c("i", { staticClass: "fas fa-volume-up" })
                                  : _vm.playingMessageIndex === -1
                                  ? _c("i", {
                                      staticClass: "fas fa-stop-circle",
                                    })
                                  : _c("i", {
                                      staticClass: "fas fa-volume-up",
                                    }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.messages, function (msg, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "chatbox-message",
                    class: [
                      msg.sender,
                      "d-flex",
                      msg.sender === "user" ? "justify-content-end" : "gap-2",
                      "mb-3",
                    ],
                    style: {
                      opacity: msg.opacity || 1,
                      transform: msg.transform || "translateY(0)",
                    },
                  },
                  [
                    msg.sender === "bot"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "bot-image d-flex align-items-center justify-content-center",
                          },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src: "/assets/images/rebot-icon.svg",
                                alt: "Bot",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "message-content" }, [
                      _c("div", {
                        staticClass: "mb-1 message-txt chat-message-content",
                        domProps: { innerHTML: _vm._s(msg.content) },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between",
                        },
                        [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(msg.time)),
                          ]),
                          _vm._v(" "),
                          msg.sender === "bot" && msg.content?.length < 1000
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn p-0 speaker-btn",
                                  class: {
                                    speaking: _vm.playingMessageIndex === index,
                                  },
                                  attrs: {
                                    disabled: _vm.isLoadingAudio,
                                    title: _vm.Lang.get(
                                      "messages.listen_to_message"
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.playTextToSpeech(
                                        msg.originalText || msg.content,
                                        index
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.playingMessageIndex !== index
                                    ? _c("i", {
                                        staticClass: "fas fa-volume-up",
                                      })
                                    : _c("i", {
                                        staticClass: "fas fa-stop-circle",
                                      }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "chatbox-footer d-flex align-items-center p-3 gap-2",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn p-0 mic-btn",
                  class: { recording: _vm.isRecording },
                  attrs: {
                    disabled: _vm.isProcessing,
                    title: _vm.isRecording
                      ? _vm.Lang.get("messages.stop_recording")
                      : _vm.Lang.get("messages.start_recording"),
                  },
                  on: { click: _vm.toggleVoiceRecording },
                },
                [
                  _c("img", {
                    staticClass: "record_disabled",
                    attrs: {
                      src: "/assets/images/microphone-2.svg",
                      alt: "microphone",
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "record_active",
                    attrs: {
                      src: "/assets/images/microphone-3.svg",
                      alt: "microphone",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "chat-input d-flex align-items-center flex-grow-1 px-2 border rounded position-relative",
                  class: { recording: _vm.isRecording },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.chatInput,
                        expression: "chatInput",
                      },
                    ],
                    ref: "chatInputRef",
                    staticClass: "form-control border-0 py-1",
                    class: { "voice-input": _vm.voiceInputStyling },
                    attrs: {
                      type: "text",
                      placeholder: _vm.isProcessing
                        ? _vm.Lang.get("messages.processing")
                        : _vm.Lang.get("messages.type_here"),
                      disabled: _vm.isProcessing,
                    },
                    domProps: { value: _vm.chatInput },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return _vm.sendChatbotMessage.apply(null, arguments)
                      },
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.chatInput = $event.target.value
                        },
                        _vm.onInputChange,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    ref: "recordingWave",
                    staticClass: "recording-wave",
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn send-msg-btn p-0 d-flex align-items-center justify-content-center rounded",
                  attrs: {
                    disabled: !_vm.canSend,
                    title: _vm.Lang.get("messages.send"),
                  },
                  on: { click: _vm.sendChatbotMessage },
                },
                [
                  _c("img", {
                    attrs: { src: "/assets/images/Send.svg", alt: "Send" },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "smoke-container" }, [
      _c("span", { staticClass: "smoke-particle p1" }),
      _vm._v(" "),
      _c("span", { staticClass: "smoke-particle p2" }),
      _vm._v(" "),
      _c("span", { staticClass: "smoke-particle p3" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "rebot-icon d-flex align-items-center justify-content-center bg-white rounded-circle",
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: "/assets/images/rebot-icon.svg", alt: "Chatbot Icon" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "bot-image d-flex align-items-center justify-content-center",
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: "/assets/images/rebot-icon.svg", alt: "Bot" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }